import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const ease = [0.16, 1, 0.3, 1];

const SHOWCASE_IMG =
  "https://customer-assets.emergentagent.com/job_capital-motion/artifacts/s16cwpv9_ChatGPT%20Image%20Apr%2028%2C%202026%2C%2012_09_28%20AM.png";

const meta = [
  { l: "Tracking", v: "Hedge funds + banking" },
  { l: "Currencies", v: "Multi-currency" },
  { l: "Custody", v: "Audited partners" },
  { l: "Reports", v: "Investor-grade export" },
];

export default function Showcase() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], [-30, 60]);

  return (
    <section
      id="showcase"
      ref={ref}
      className="relative bg-[#0A0B0D] py-32 sm:py-40 lg:py-48 overflow-hidden"
      data-testid="showcase-section"
    >
      <div className="max-w-[1700px] mx-auto px-6 sm:px-10 lg:px-12 grid grid-cols-12 gap-6 lg:gap-10">
        {/* Left meta column */}
        <div className="col-span-12 lg:col-span-3 lg:pt-2 flex flex-col gap-12 order-2 lg:order-1">
          <div>
            <div className="t-mono text-[#7A7A78]">— § 03 / The Platform</div>
            <h3 className="mt-4 t-display text-[#F4F2EC] text-3xl sm:text-4xl leading-[0.98] max-w-xs">
              A unified portfolio, calmly displayed.
            </h3>
            <p className="mt-5 t-body text-sm text-[#BFBDB6] leading-relaxed max-w-xs">
              Hedge funds, banking activity and private holdings — viewed and
              reported as one unified portfolio. Real-time analytics, exposure
              breakdowns, and exportable reports designed for institutional
              rigour.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-y-6 gap-x-4">
            {meta.map((m) => (
              <div key={m.l}>
                <div className="t-mono text-[#7A7A78]">{m.l}</div>
                <div className="mt-1 t-body text-sm text-[#F4F2EC]">{m.v}</div>
              </div>
            ))}
          </div>

          <div className="hidden lg:block t-mono text-[#7A7A78] mt-auto">
            Real-time hedge fund tracking · multi-currency consolidation
          </div>
        </div>

        {/* Image plate */}
        <div className="col-span-12 lg:col-span-9 order-1 lg:order-2 relative">
          <motion.div
            style={{ y: imgY }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ duration: 1.6, ease }}
            className="relative frame aspect-[4/3] sm:aspect-[16/10] w-full"
          >
            <img
              src={SHOWCASE_IMG}
              alt="Credit Stone Digital — product"
              className="w-full h-full object-cover object-center"
              draggable="false"
            />
            {/* corner labels HELIOT-style */}
            <div className="absolute top-5 left-6 t-mono text-[#F4F2EC]/85">
              CSD AW26
              <br />
              <span className="text-[#F4F2EC]/55">Quiet Equilibrium</span>
            </div>
            <div className="absolute bottom-5 left-6 t-mono text-[#F4F2EC]/85">07</div>
            <div className="absolute bottom-5 left-1/2 -translate-x-1/2 t-mono text-[#F4F2EC]/85">
              CSD
            </div>
            <div className="absolute bottom-5 right-6 t-mono text-[#F4F2EC]/85">25</div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
